import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxEzModalService} from '../../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';

@Component({
    selector: 'app-rank-select-modal',
    templateUrl: './mastery-select-modal.component.html',
    styleUrls: ['./mastery-select-modal.component.scss']
})
export class MasterySelectModalComponent {
    @Input() min: number;
    @Input() max: number;
    @Output() selected = new EventEmitter<string>();

    constructor(public modalService: NgxEzModalService) {
    }

    public onSelect(rank) {
        this.selected.emit(rank);
        this.modalService.closeOutletModals('public');
    }
}
